import React, { useState } from "react";
import { useSelector } from "react-redux";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import ConfirmDeletePopup from "../../message/confirmDeletePopup/ConfirmDeletePopup";
import classes from "./ToolHoverActions.module.css";

const ToolHoverActions = ({ tool, onEdit, onDelete, containerClass }) => {
    const { texts } = useSelector(state => state.translate);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        setShowConfirm(true);
    };

    const handleConfirmDelete = () => {
        setShowConfirm(false);
        onDelete(tool);
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        onEdit(tool);
    };

    return (
        <div className={containerClass}>
            {onDelete &&
                <button
                    className={classes.ActionBtn}
                    tooltip={texts.deleteTool}
                    onClick={handleDeleteClick}
                >
                    <Icon name={iconsList.delete} size="18px" color="white" />
                </button>
            }
            {onEdit &&
                <button
                    className={classes.ActionBtn}
                    tooltip={texts.editTool}
                    onClick={handleEdit}
                >
                    <Icon name={iconsList.edit} size="18px" color="white" />
                </button>
            }
            {showConfirm &&
                <ConfirmDeletePopup
                    onClose={() => setShowConfirm(false)}
                    onClick={handleConfirmDelete}
                    text={texts.confirmDeleteToolText}
                    confirmText={texts.confirmDeleteToolTitle}
                />
            }
        </div>
    );
};

export default ToolHoverActions;
